import React, { Component } from 'react';
// import ContentWrapper from "./../../template/Layout/ContentWrapper";
// import ClientesList from '../../../services/storageClient.js';
// const clientSave = new ClientesList();
import { Tab, Button } from "semantic-ui-react";
import OpenTickets from "./Components/OpenTickets";
import ClosedTickets from "./Components/ClosedTickets";
import { Col, } from "reactstrap";
import Etiquetas from './Etiquetas/Labels'

class Help_Desk extends Component {
    constructor(props) {
        console.log('props---------->', props);
        super(props);
        this.state = {
            Etiquetas: Etiquetas.Ingles,
            // panes: []
        };
    }

    // componentDidMount = () => {
    //     this.buildPanes()
    // }

    // buildPanes = () => {
    //     let { panes } = this.state
    //     const paness = Etiquetas.Ingles.Tabs.map((e, key) => {
    //         console.log('e', e);
    //         panes.push(`menuItem: ${e.label}, render:()=><${e.render}>`)
    //     })
    //     console.log('panes', panes);
    // }

    render() {
        const { Etiquetas } = this.state
        return (
            <Col>
                <div className="content-heading">
                    <div style={{ paddingTop: 15 }}>
                        <i className="far fa-question-circle mr-2" />
                        <span>{Etiquetas.Tittle}</span>
                    </div>
                </div>
                <Col xs={12} style={{ textAlign: 'right' }}>
                    <Button color='green'>
                        <i className='fas fa-plus-circle mr-2' />
                        {Etiquetas.ButtonNewTicket}
                    </Button>
                </Col>
                <Tab
                    panes={[
                        { menuItem: `${Etiquetas.Tab1}`, render: () => <OpenTickets /> },
                        { menuItem: `${Etiquetas.Tab2}`, render: () => <ClosedTickets /> },
                    ]}
                >
                </Tab>
            </Col>
        );
    }
}

export default Help_Desk;
